
// SVG Icon: right
export default { id: "terriajs-right" };
export const id = "terriajs-right";
export const name = "right";
